import React from 'react';
import type { ButtonProps as AntdButtonProps } from 'antd';
import type { SizeType } from 'antd/es/config-provider/SizeContext';

import Button from './styled.ts';

export type Variant =
    | 'primary'
    | 'secondary'
    | 'outline'
    | 'transparent'
    | 'success'
    | 'link'
    | 'purple'
    | 'purpleOutline'
    | 'warning';

export interface BaseButtonProps extends AntdButtonProps {
    $customType?: Variant;
    icon?: React.ReactNode;
    size?: SizeType;
    disabled?: boolean;
    loading?: boolean;
    onClick?: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void;
    children?: React.ReactNode;
}

export const BaseButton = React.forwardRef<HTMLButtonElement, BaseButtonProps>(
    ({ $customType = 'primary', size = 'large', children, ...rest }, ref) => (
        <Button ref={ref} $customType={$customType} size={size} {...rest}>
            {children}
        </Button>
    ),
);
